import { render, staticRenderFns } from "./AuthCard.vue?vue&type=template&id=50074a93&scoped=true&"
import script from "./AuthCard.vue?vue&type=script&lang=js&"
export * from "./AuthCard.vue?vue&type=script&lang=js&"
import style0 from "./AuthCard.vue?vue&type=style&index=0&id=50074a93&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50074a93",
  null
  
)

export default component.exports